import { NgModule } from '@angular/core';
import { NzDatePipe } from './nz-date.pipe';

@NgModule({
  declarations: [ NzDatePipe ],
  exports     : [ NzDatePipe ]
})
export class NzUtilModule {

}
